/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ecommerce_Amazon_Tools_Work_0_DescInputs */

const en_svc_ecommerce_amazon_tools_work_0_desc = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automated product-sync pipelines that keep an e-commerce catalog fresh across channels without a single manual export.`)
};

const ar_svc_ecommerce_amazon_tools_work_0_desc = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خطوط أنابيب مزامنة منتجات آلية تُبقي كتالوج التجارة الإلكترونية محدّثًا عبر القنوات دون أي تصدير يدوي.`)
};

const bn_svc_ecommerce_amazon_tools_work_0_desc = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অটোমেটেড প্রোডাক্ট-সিঙ্ক পাইপলাইন যা একটিও ম্যানুয়াল এক্সপোর্ট ছাড়াই একাধিক চ্যানেলে ই-কমার্স ক্যাটালগ তাজা রাখে।`)
};

const de_svc_ecommerce_amazon_tools_work_0_desc = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatisierte Produktsynchronisierungspipelines, die einen E-Commerce-Katalog über alle Kanäle hinweg auf dem neuesten Stand halten, ohne dass ein einziger manueller Export erforderlich ist.`)
};

const es_svc_ecommerce_amazon_tools_work_0_desc = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pipelines automatizados de sincronización de productos que mantienen actualizado un catálogo de comercio electrónico en todos los canales sin una sola exportación manual.`)
};

const fr_svc_ecommerce_amazon_tools_work_0_desc = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pipelines automatisés de synchronisation des produits qui maintiennent à jour un catalogue de commerce électronique sur tous les canaux sans une seule exportation manuelle.`)
};

const pt_svc_ecommerce_amazon_tools_work_0_desc = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pipelines automatizados de sincronização de produtos que mantêm um catálogo de comércio eletrônico atualizado em todos os canais sem uma única exportação manual.`)
};

const zh_svc_ecommerce_amazon_tools_work_0_desc = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动产品同步管道让电商目录在各渠道保持新鲜，一次手动导出都不用。`)
};

const tr_svc_ecommerce_amazon_tools_work_0_desc = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tek bir manuel aktarma olmadan e-ticaret kataloğunu kanallar arası taze tutan otomatik ürün senkron hatları.`)
};

const ru_svc_ecommerce_amazon_tools_work_0_desc = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматизированные продуктовые пайплайны держат каталог e-commerce свежим между каналами, без единого ручного экспорта.`)
};

const pl_svc_ecommerce_amazon_tools_work_0_desc = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zautomatyzowane potoki synchronizacji produktów, które zapewniają aktualność katalogu e-commerce w różnych kanałach bez konieczności pojedynczego ręcznego eksportu.`)
};

/**
* | output |
* | --- |
* | "Automated product-sync pipelines that keep an e-commerce catalog fresh across channels without a single manual export." |
*
* @param {Svc_Ecommerce_Amazon_Tools_Work_0_DescInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ecommerce_amazon_tools_work_0_desc = /** @type {((inputs?: Svc_Ecommerce_Amazon_Tools_Work_0_DescInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ecommerce_Amazon_Tools_Work_0_DescInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ecommerce_amazon_tools_work_0_desc(inputs)
	if (locale === "bn") return bn_svc_ecommerce_amazon_tools_work_0_desc(inputs)
	if (locale === "de") return de_svc_ecommerce_amazon_tools_work_0_desc(inputs)
	if (locale === "es") return es_svc_ecommerce_amazon_tools_work_0_desc(inputs)
	if (locale === "fr") return fr_svc_ecommerce_amazon_tools_work_0_desc(inputs)
	if (locale === "pt") return pt_svc_ecommerce_amazon_tools_work_0_desc(inputs)
	if (locale === "zh") return zh_svc_ecommerce_amazon_tools_work_0_desc(inputs)
	if (locale === "tr") return tr_svc_ecommerce_amazon_tools_work_0_desc(inputs)
	if (locale === "ru") return ru_svc_ecommerce_amazon_tools_work_0_desc(inputs)
	if (locale === "pl") return pl_svc_ecommerce_amazon_tools_work_0_desc(inputs)
	return en_svc_ecommerce_amazon_tools_work_0_desc(inputs)
});
export { svc_ecommerce_amazon_tools_work_0_desc as "svc_ecommerce-amazon-tools_work_0_desc" }